<div class="target-input">
  <p-autoComplete
    #ac
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    [ngModelOptions]="{ standalone: true }"
    [suggestions]="suggestions"
    (completeMethod)="search($event)"
    (onSelect)="onSelect($event)"
    (onBlur)="onBlur()"
    [group]="true"
    optionGroupLabel="label"
    optionGroupChildren="items"
    [dropdown]="true"
    [forceSelection]="false"
    [minLength]="0"
    [delay]="0"
    scrollHeight="260px"
    [placeholder]="placeholder"
    styleClass="target-input__ac"
    inputStyleClass="inputfield w-full font-mono"
    appendTo="body"
  >
    <ng-template let-g pTemplate="group">
      <span class="text-500 text-xs font-semibold">{{ g.label }}</span>
    </ng-template>

    <ng-template let-c pTemplate="item">
      <div class="flex flex-column" style="line-height: 1.25">
        <span class="font-mono">{{ c.path }}</span>
        <small class="text-500">
          {{ c.title }}
          <span *ngIf="c.note" class="text-orange-600"> · {{ c.note }}</span>
        </small>
      </div>
    </ng-template>
  </p-autoComplete>

  <!-- Warns, never blocks: the candidate list cannot see v3's file routes, so
       a false negative is possible and must not stop a save. -->
  <small *ngIf="unknownPath" class="block mt-1 text-orange-600">
    <i class="pi pi-exclamation-triangle" style="font-size: 0.75rem"></i>
    No page at this address — check the spelling, or ignore this if the page is still to be made.
  </small>
</div>
